/**
 * /partner/finder-dashboard — Finder dashboard (route shell).
 * Screen impl in `./finder-dashboard-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/partner/finder-dashboard')({
  component: lazyRouteComponent(
    () => import('./finder-dashboard-screen'),
    'FinderDashboard',
  ),
});
